import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (!data?.user_id) {
          console.error("Auth exchange: response missing user_id", data);
          navigate("/login", { replace: true });
          return;
        }
        setUser(data);
        // Single source of truth for URL cleanup — let React Router handle it
        navigate("/dashboard", { replace: true });
      } catch (e) {
        console.error("Auth exchange failed", e?.response?.status, e?.response?.data || e?.message);
        // 403 = allowlist blocked → route to a friendly page
        if (e?.response?.status === 403) {
          const msg = e?.response?.data?.detail || "Geen toegang.";
          navigate("/login", { replace: true, state: { deniedMessage: msg } });
        } else {
          navigate("/login", { replace: true });
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="text-slate-500 text-sm">Bezig met aanmelden…</div>
    </div>
  );
}
